const getters = {
  accessRoutes: state => {
    return state.accessRoutes
  },
  hasLogin: state => {
    return state.role > 0
  },
  getUserInfo: state => {
    return state.userInfo
  },
  getUserName: state => {
    return state.name
  },
  getUserNameEn: state => {
    return state.name_en
  },
  getUserRole: state => {
    return state.role
  },
  getAllRoutes: state => {
    return state.allRoutes
  },
  getRoleList: state => {
    return state.roleList
  },
  getExamTypeList: state => {
    return state.examTypeList
  },
  getExamGradeStatusList: state => {
    return state.examGradeStatusList
  },
  getFinalExamGradeStatusList: state => {
    return state.finalExamGradeStatusList
  },
  getFinalExamGradeResStatusList: state => {
    return state.finalExamGradeResStatusList
  },
  getFinalExamGradePayStatusList: state => {
    return state.finalExamGradePayStatusList
  },
  getFinalExamGradeRegStatusList: state => {
    return state.finalExamGradeRegStatusList
  },
  getFinalExamGradeQuaStatusList: state => {
    return state.finalExamGradeQuaStatusList
  },
  getFinalExamGradeTypeList: state => {
    return state.finalExamGradeTypeList
  },
}
export default getters
